export function getClientTag(country) {
  const env = process.env.VUE_APP_ENV;
  console.log(process.env.VUE_APP_ENV);

  if (country === 'hongkong') {
    return env === 'production' ? 'HK-keeta' : 'HK-test';
  }
  if (country === 'uk') {
    return env === 'production' ? 'UK-keeta' : 'UK-test';
  }
  return '';
}
